import { mapGetters } from 'vuex';
export const modelOpenRouter = {
  computed: {
    ...mapGetters({
      getModelOpenState: 'diagnosis/getModelOpenState'
    })
  },
  beforeRouteLeave (to, from, next) {
    if (this.getModelOpenState) {
      next(false);
    } else {
      next();
    }
  }
};
